import { render, staticRenderFns } from "./DiseaseDetailForMdt.vue?vue&type=template&id=89a1efe6&scoped=true"
import script from "./DiseaseDetailForMdt.vue?vue&type=script&lang=js"
export * from "./DiseaseDetailForMdt.vue?vue&type=script&lang=js"
import style0 from "./DiseaseDetailForMdt.vue?vue&type=style&index=0&id=89a1efe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a1efe6",
  null
  
)

export default component.exports